import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot,  CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class UserAuthorizedGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isUserEntitledApiStore = this.userService.isUserEntitledApiStore();
    if (!isUserEntitledApiStore) {
      // TODO show message;
      this.router.navigateByUrl('apis');
    }
    return isUserEntitledApiStore;
  }
}
